/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./AdjustmentDetails.module.css";

interface InfoColumnProps {
  lastUpdated: string;
  totalBorrowerFees: string;
  cuRetailRate: string;
  protectedLoanAmount: string;
  payRate: string;
  premiumDue: string;
  totalAmount: string;
}

const InfoColumn: React.FC<InfoColumnProps> = ({
  lastUpdated,
  totalBorrowerFees,
  cuRetailRate,
  protectedLoanAmount,
  payRate,
  premiumDue,
  totalAmount,
}) => {
  return (
    <div className={styles.infoColumn}>
      <h2 className={styles.lastUpdated}>Last Updated</h2>
      <p className={styles.date}>{lastUpdated}</p>
      <p className={`${styles.infoItem} ${styles.totalBorrowerFees}`}>
        Total Borrower Fees
      </p>
      <p className={styles.infoItem}>CU Retail Rate</p>
      <p className={`${styles.infoItem} ${styles.protectedLoanAmount}`}>
        Protected Loan Amount
      </p>
      <p className={styles.infoItem}>Pay Rate</p>
      <p className={`${styles.infoItem} ${styles.premiumDue}`}>Premium Due</p>
      <p className={`${styles.infoItem} ${styles.totalAmount}`}>Total Amount</p>
      <div className={styles.buttonGroup}>
        <button className={`${styles.button} ${styles.primaryButton}`}>
          <span className={styles.buttonContent}>Edit</span>
        </button>
        <button className={`${styles.button} ${styles.secondaryButton}`}>
          <span className={styles.buttonContent}>Save</span>
        </button>
      </div>
    </div>
  );
};

export default InfoColumn;
